import React, {ReactNode} from "react";
import serviceWorldContentBoxStyle from "./serviceWorldContentBoxStyle";
import { Paper } from "@mui/material";
import Grid from "@mui/material/Grid";
import Typography from "@mui/material/Typography";
import IconWrapper, { IconWrapperProps } from "../IconWrapper/IconWrapper";

type ServiceWorldContentBoxProps = {
  icon?: IconWrapperProps["icon"] | null;
  altText?: string;
  headline: string;
  children?: ReactNode;
};

const ServiceWorldContentBox = ({ icon = null, altText = "Icon", headline, children }: ServiceWorldContentBoxProps) => {
  return (
    <Paper elevation={4} sx={serviceWorldContentBoxStyle.contentBoxContainer}>
      <Grid
        container
        wrap={"nowrap"}
        sx={[{
          justifyContent: "center"
        }, serviceWorldContentBoxStyle.contentBoxHeadline]}>
        <Grid>
          <Grid container sx={{
            alignItems: "center"
          }}>
            {icon && (
              <Grid sx={serviceWorldContentBoxStyle.imageCircleContainer}>
                <IconWrapper icon={icon} alt={altText} sx={serviceWorldContentBoxStyle.headerIcon} />
              </Grid>
            )}
            <Grid>
              <Typography variant={"h5"} component={"h3"} align={"center"} sx={{
                paddingX: "2rem"
              }}>
                {headline}
              </Typography>
            </Grid>
          </Grid>
        </Grid>
      </Grid>
      {children}
    </Paper>
  );
};

export default ServiceWorldContentBox;
